<form [formGroup]="form">
  <div clickOutside (clickOutside)="col.showSearchPopup = false">
    <div (click)="col.showSearchPopup = true" class="table-header-wrapper">
      <span class="table-header__text">{{ col.header }}</span>
      <ng-container
        *ngIf="col.action === 'sort' || col.action === 'sort&search'"
      >
        <mat-icon (click)="onSortClick($event, sortIcon)">
          {{ sortIcon }}
        </mat-icon>
        <input type="hidden" formControlName="sort" />
      </ng-container>
    </div>
    <ng-container
      *ngIf="col.action === 'search' || col.action === 'sort&search'"
    >
      <div
        [style.display]="col.showSearchPopup ? 'block' : 'none'"
        class="search-popup"
      >
        <ng-container [ngSwitch]="col.columnType">
          <ng-container *ngSwitchCase="'String'">
            <div class="fpx-form-field">
              <mat-select
                [formControlName]="'condition'"
                panelClass="fpx-select-panel"
              >
                <ng-container
                  *ngIf="stringSelectableList$ | async as stringDataList"
                >
                  <mat-option
                    *ngFor="let stringData of stringDataList"
                    [value]="stringData.id"
                  >
                    {{ stringData.text }}</mat-option
                  >
                </ng-container>
              </mat-select>
            </div>
            <div class="fpx-form-field">
              <input type="text" [formControlName]="'filter'" />
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'Numeric'">
            <div class="fpx-form-field">
              <mat-select
                [formControlName]="'condition'"
                panelClass="fpx-select-panel"
              >
                <ng-container
                  *ngIf="stringSelectableList$ | async as stringDataList"
                >
                  <mat-option
                    *ngFor="let stringData of stringDataList"
                    [value]="stringData.id"
                  >
                    {{ stringData.text }}</mat-option
                  >
                </ng-container>
              </mat-select>
            </div>
            <div class="fpx-form-field">
              <input type="number" [formControlName]="'filter'" />
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'Date'">
            <div class="fpx-form-field">
              <mat-select
                [formControlName]="'condition'"
                panelClass="fpx-select-panel"
              >
                <ng-container
                  *ngIf="stringSelectableList$ | async as stringDataList"
                >
                  <mat-option
                    *ngFor="let stringData of stringDataList"
                    [value]="stringData.id"
                  >
                    {{ stringData.text }}</mat-option
                  >
                </ng-container>
              </mat-select>
            </div>
            <div class="fpx-form-field">
              <input type="text" [formControlName]="'filter'" />
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </div>
</form>
